import {ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot} from '@angular/router';
import {inject, Injectable} from "@angular/core";
import {CommonConstants} from "../constants/common-constants";
import {HelperService} from "../api-common-service/helper.service";
@Injectable({
  providedIn: 'root'
})

export class PermissionsService {

  constructor(private helperService: HelperService, private router :Router) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    if (this.helperService.checkLogin(CommonConstants.TOKEN)) {
      return true;
    } else {
      this.router.navigate(['/login']);
      return false;
    }
  }
}

export const authGuard: CanActivateFn = (next: ActivatedRouteSnapshot, state: RouterStateSnapshot): any => {
  return inject(PermissionsService).canActivate(next, state);
};
